module.exports = __webpack_public_path__ + "static/img/spray--02_2x.fe7314d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/spray--02_2x.png
// module id = 8qsH
// module chunks = 1